<template>
  <div class="site-tool">
    <el-popover placement="left" width="180" trigger="hover" style="border-radius: 8px;">
      <div class="site-tool-item" slot="reference" style="border-top: none">
        <img src="~@/assets/imgs/mobile.png" alt="" class="site-tool-icon" />
        <div class="site-tool-title">电话咨询</div>
      </div>
      <div class="d-flex align-items-center px-0" style="font-size: 18px; justify-content: center;">
        <svg-icon name="icon-phone" class="text-primary me-2"></svg-icon>
        <div class="text-primary">
          4000-996-660
        </div>
      </div>
    </el-popover>
    <el-popover placement="left" width="180" trigger="hover">
      <div class="site-tool-item" slot="reference">
        <img src="~@/assets/imgs/wechat.png" alt="" class="site-tool-icon" />
        <div class="site-tool-title">微信咨询</div>
      </div>
      <div class="wechat-qrcode">
        <div class="wechat-qrcode-title">
          添加企业微信 <br />
          为您提供1对1的答疑解惑
        </div>
        <div class="wechat-qrcode-img">
          <img src="~@/assets/imgs/wechat-qrcode.png" alt="" />
        </div>
      </div>
    </el-popover>
    <div class="site-tool-item" @click="backTop">
      <img src="~@/assets/imgs/back-top.png" alt="" class="site-tool-icon" />
      <div class="site-tool-title">回到顶部</div>
    </div>
  </div>
</template>

<script>
// import api from '@/api'
import { mapState } from 'vuex'
import $ from 'jquery'
export default {
  name: 'App',
  data() {
    return {}
  },
  methods: {
    init() {},
    backTop() {
      $('#app').animate(
        {
          scrollTop: 0
        },
        0
      )
    }
  },
  computed: {
    ...mapState([])
  },
  components: {},
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init(to, from)
    })
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    next()
  }
}
</script>

<style scoped lang="scss">
$primary: #4876f9;
.site-tool {
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  border-radius: 8px 0 0 8px;
  height: 240px;
  overflow: hidden;
  z-index: 1000;

  .site-tool-item {
    width: 68px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: $primary;
    color: white;
    flex-direction: column;
    border-top: 1px solid #7396fb;

    &:hover {
      background: #3462e5;
      cursor: pointer;
    }
  }

  .site-tool-icon {
    width: 25px;
    margin-bottom: 5px;
  }
  .site-tool-title {
    font-size: 12px;
  }
}

.wechat-qrcode {
  padding: 10px 0;

  .wechat-qrcode-title {
    font-size: 12px;
    color: $primary;
    margin-bottom: 10px;
    text-align: center;
  }

  .wechat-qrcode-img {
    width: 100px;
    margin: auto;

    img {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/siteTool.vue